import { useMutation } from "@tanstack/react-query";
import { CheckCircle2, LogOut } from "lucide-react";
import { useState } from "react";
import { api } from "../../api/client";
import { AppUser } from "../../api/types";
import { ErrorState } from "../../components/Feedback";
import { currentBrand } from "../../config/brand";

export function TermsAcceptanceModal({ user, onAccepted, onLogout }: {
  user: AppUser;
  onAccepted(user: AppUser): void;
  onLogout(): Promise<void>;
}) {
  const brand = currentBrand();
  const [accepted, setAccepted] = useState(false);
  const mutation = useMutation({
    mutationFn: () => api<{ user: AppUser }>("/auth/accept-terms", { method: "POST" }),
    onSuccess: (data) => onAccepted(data.user),
  });

  return (
    <main className="login-page">
      <section className="login-panel terms-gate-panel" aria-labelledby="terms-title">
        <img className="login-logo" src={brand.logo} alt={brand.name} />
        <div className="login-heading">
          <h1 id="terms-title">Termos de uso e privacidade</h1>
          <p>Confirme a leitura da versao vigente para liberar o acesso de {user.name}.</p>
        </div>
        <div className="terms-content">
          <div className="document-links">
            <a href="/termos.html" target="_blank" rel="noreferrer">Termos de uso</a>
            <a href="/privacidade.html" target="_blank" rel="noreferrer">Politica de privacidade</a>
            <a href="/cookies.html" target="_blank" rel="noreferrer">Cookies</a>
            <a href="/retencao.html" target="_blank" rel="noreferrer">Retencao</a>
          </div>
          <label className="checkbox-row checkbox-confirm">
            <input type="checkbox" checked={accepted} onChange={(event) => setAccepted(event.target.checked)} />
            <span>Li e aceito os Termos de Uso e a Politica de Privacidade.</span>
          </label>
          {mutation.error ? <ErrorState message={mutation.error.message} /> : null}
          <div className="terms-gate-actions">
            <button className="button button-secondary" type="button" onClick={() => void onLogout()} disabled={mutation.isPending}>
              <LogOut size={17} />Sair
            </button>
            <button className="button button-primary" type="button" disabled={!accepted || mutation.isPending} onClick={() => mutation.mutate()}>
              <CheckCircle2 size={17} />
              {mutation.isPending ? "Registrando" : "Confirmar aceite"}
            </button>
          </div>
        </div>
      </section>
    </main>
  );
}